import  { useState,  } from "react";

import { DictionaryType } from "../../types";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import {

  useLogExportFileMutation,

} from "../../lib/redux/services/Api";

import {
  Controller,
  useForm,
} from "react-hook-form";
import { toast } from "react-toastify";
import {  toastMessage } from "../../utils/utils";

import {  useGetAllWalletServicesQuery } from "../../lib/redux/services/sections/Customers";
import ValidateError from "./ValidateError";

import Button from "./Button";
import DateInput from "./DateInput";
import MultiSearchableSelect from "./MultiSearchableSelect";
import { useGetAllClubsByNameQuery, useGetAllClubsQuery } from "../../lib/redux/services/sections/Clubs";
import { Tooltip } from "react-tooltip";


type Props = {
  id: any;
  info?: any;
  onClose: any;

};
type FormType = {
  date_from: string;
  date_to: string;
  service_ids: number[];
  club_id: number;
};
function LogExportModal({ id, info,   onClose }: Props) {
      const club_id = useSelector((state: any) => state.user.selectedClub);
      const orgId = useSelector((state: any) => state.user.user?.org_id);
        const [options, setOptions] = useState([]);
        const [exportFile] = useLogExportFileMutation()
 const {shared,pricing}:DictionaryType = useGetDictionary();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const {
    control,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
    setValue,
    getValues,
    trigger,
  } = useForm<FormType>({
    defaultValues: {},
  });
  const dateFrom = watch("date_from");
  const dateTo = watch("date_to");
  const handleOption = (options: any) => {
    const selectedMethod = watch("service_ids") || [];
    if (selectedMethod?.includes(7)) {
      return options.filter((item: any) => item.id == 7);
    } else if (!selectedMethod.includes(7) && selectedMethod.length !== 0) {
      return options.filter((item: any) => item.id !== 7);
    } else {
      return options;
    }
  };
  const handleExportFile =(response:any)=>{
    
    
       const blob = new Blob([response.blob], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    
  let filename = `Export logs from ${dateFrom} to ${dateTo}.xlsx`;

 const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download =filename; // filename
    link.click();
    window.URL.revokeObjectURL(url);

  }

  const onSubmit = async (formData: FormType) => {
    console.log(formData);
      let services = formData.service_ids;
      if (services.includes(7)) {
        services = options.filter((option:any)=> option.id !== 7).map((option:any) => option.id);
      }
     
      
      
      try {
         await toast.promise(
          exportFile({   
             ...formData,
             service_ids:services
          }).unwrap().then((res)=>{
            handleExportFile(res)
            
          }),
          toastMessage()
        );
      
        
        onClose?.();
      } catch (error) {
        
      }
  };
  return (
    <>
      <h3 className="font-bold text-3xl text-center p-5 ">Export Log</h3>
      
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="p-6 text-white rounded-lg flex flex-col gap-6 h-[calc(100%-65px)] justify-between items-start w-full max-w-[500px] px-[60px]"
      >
        <div className="flex flex-col items-start gap-6 w-full">
          <div className="flex w-full gap-2">
             <div className="w-full flex-1 mobile:min-w-[200px]">
                          <Controller
                            name="date_from"
                            rules={{ required: true }}
                            control={control}
                            render={({ field }) => (
                              <DateInput
                                placeHolder={pricing.start_date}
                                
                                dateInputProps={{ ...field }}
                                
                                name="start_date"
                                title={pricing.start_date}
                                //@ts-ignore
                                handleChangeEvent={(e) => {
                                  setValue("date_from", e.replace("Sept", "Sep"));
                                  
                                  trigger("date_from");
                                  trigger("date_to");
                                }}
                              />
                            )}
                          />
            
                          {errors.date_from && errors.date_from.type === "required" && (
                            <ValidateError />
                          )}
                        </div>
                        <div className="w-full flex-1 mobile:min-w-[200px]">
                          <Controller
                            name="date_to"
                            rules={{ required: true }}
                            control={control}
                            render={({ field }) => (
                              <DateInput
                                placeHolder={pricing.end_date}
                                
                                dateInputProps={{ ...field }}
                                
                                name="start_date"
                                title={pricing.end_date}
                                //@ts-ignore
                                handleChangeEvent={(e) => {
                                  setValue("date_to", e.replace("Sept", "Sep"));
                                  
                                  trigger("date_from");
                                  trigger("date_to");
                                }}
                              />
                            )}
                          />
            
                          {errors.date_to && errors.date_to.type === "required" && (
                            <ValidateError />
                          )}
                        </div>
          </div>
          <div className="w-full flex-1 min-w-[250px]">
                      <label className="block text-sm mb-2 text-primary">
                        Allowed services <span className="text-red-500">*</span>
                      </label>
                      <Controller
                        control={control}
                        name="service_ids"
                        rules={{ required: true }}
                        render={({ field, fieldState: { error } }) => (
                          <>
                            <MultiSearchableSelect
                              fetchFunction={useGetAllWalletServicesQuery}
                              field={field}
                              maxMenuHight="150px"
                              valueKey="id"
                              pathParams={{
                                org_id: orgId,
                                type:"log_export"
                              }}
                              position="top"
                              handleOption={handleOption}
                              AfterLoading={(options: any) => {
                                console.log(options);
          
                                setOptions(options);
                              }}
                              addOption={{
                                id: 7,
                                name: "Select All",
                              }}
                            />
                            {error && <ValidateError />}
                          </>
                        )}
                      />
                    </div>
            <div className="w-full flex-1 min-w-[250px]">
                      <label className="block text-sm mb-2 text-primary">
                        Club <span className="text-red-500">*</span>
                      </label>
                      <Controller
                        control={control}
                        name="club_id"
                        rules={{ required: true }}
                        render={({ field, fieldState: { error } }) => (
                          <>
                            <MultiSearchableSelect
                              fetchFunction={useGetAllClubsByNameQuery}
                              field={field}
                              valueKey="id"
                              pathParams={{
                                org_id: orgId,
                              }}
                              position="top"
                              isMulti={false}
                            />
                            {error && <ValidateError />}
                          </>
                        )}
                      />
                    </div>
        <div className="flex flex-col gap-6 justify-end items-center w-full ml-auto mr-0">
          <Button
            customeStyle="bg-primary text-white p-3 px-2 rounded-full w-full"
            text={shared.save}
            type="submit"
            width=" max-w-full w-full"
          />

          <Button
            customeStyle="text-red-500 w-full hover:border-red-500 hover:border rounded-full py-3 transition duration-300"
            text={shared.cancel}
            type="reset"
            width=" max-w-full w-full"
            onClick={(e) => {
              e.preventDefault();

              onClose?.();
            }}
          />
        </div>
        </div>
      </form>
    </>
  );
}






export default LogExportModal;
